/// Theme Hook
///
/// Use this hook to toggle between light and dark themes

import { useState, useEffect } from "react";

export const useThemeToggler = (): [string, () => void] => {
  const [themeMode, setTheme] = useState("light"); // Default to light theme

  const setMode = (mode: string) => {
    localStorage.setItem("theme", mode);
    setTheme(mode);
  };

  const themeToggler = () => {
    themeMode === "light" ? setMode("dark") : setMode("light");
  };

  useEffect(() => {
    const localTheme = localStorage.getItem("theme");
    localTheme && setTheme(localTheme);
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    if (localTheme) {
      document.documentElement.classList.add(
        localTheme === "system" ? (prefersDark ? "dark" : "light") : localTheme
      );
    }
  }, []);

  return [themeMode, themeToggler];
};
